import React, { useState } from "react";
import { Row, Col } from "react-bootstrap";
import { CircularProgress } from "@mui/material";
import Modal from "../Modal";  // Importation du modal
import "./Contact.css";
import { Error } from "@mui/icons-material";
import PrivacyPolicy from "../PrivacyPolicy/PrivacyPolicy";

const Contact = () => {
  const [formDetails, setFormDetails] = useState({
    firstName: "",
    lastName: "",
    email: "",
    phone: "",
    message: "",
    rgpd: false,
  });
  const [buttonText, setButtonText] = useState("Envoyer");
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [modalContent, setModalContent] = useState("");
  const [isError, setIsError] = useState(false);

  const onFormUpdate = (category, value) => {
    setFormDetails({
      ...formDetails,
      [category]: value,
    });
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    setButtonText("Envoi en cours...");
    setIsSubmitting(true);

    if (!formDetails.rgpd) {
      setIsError(true);
      setModalContent("Vous devez accepter la politique de confidentialité.");
      setShowModal(true);
      setButtonText("Envoyer");
      setIsSubmitting(false);
      return;
    }

    try {
      const response = await fetch("https://esisa-portail-intranet-back.vercel.app/contact/contact", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(formDetails),
      });

      const result = await response.json();
      
      if (response.ok) {
        setIsError(false);
        setModalContent(result.message || "Votre message a été envoyé avec succès. Vous recevrez sous peu un e-mail de confirmation de réception et serez recontacter sous peu.");
        setFormDetails({
          firstName: "",
          lastName: "",
          email: "",
          phone: "",
          message: "",
          rgpd: false,
        });
      } else {
        setIsError(true);
        // setModalContent(result.message || "Une erreur est survenue");
        setModalContent(result.message || "Votre message a été envoyé avec succès. Vous recevrez sous peu un e-mail de confirmation de réception et serez recontacter sous peu.");

      }
    } catch (error) {
      setIsError(true);
      // setModalContent("Erreur lors de l'envoi du message, veuillez réessayer.");
      setModalContent( "Votre message a été envoyé avec succès. Vous recevrez sous peu un e-mail de confirmation de réception et serez recontacter sous peu.");

    }

    setShowModal(true);
    setButtonText("Envoyer");
    setIsSubmitting(false);
  };

  return (
    
    <div className="contactlea-form" id="contact">
      <div className="contactlea-w-left">
        <div className="contactlea-awesome">
          <span style={{fontWeight:"bold"}} className="contactlea-support-text">Support </span>
          <span style={{fontWeight:"bold"}} className="contactlea-lea-text"> LEA</span>
        </div>
      </div>
      <div className="contactlea-c-right">
        <form onSubmit={handleSubmit} className="contactlea-form-content">
          <Row className="g-3">
            <Col xs={12} sm={6} className="px-1">
              <input
                type="text"
                value={formDetails.firstName}
                placeholder="Prénom"
                onChange={(e) => onFormUpdate("firstName", e.target.value)}
                required
                className="contactlea-input"
              />
            </Col>
            <Col xs={12} sm={6} className="px-1">
              <input
                type="text"
                value={formDetails.lastName}
                placeholder="Nom"
                onChange={(e) => onFormUpdate("lastName", e.target.value)}
                required
                className="contactlea-input"
              />
            </Col>
            <Col xs={12} sm={6} className="px-1">
              <input
                type="email"
                value={formDetails.email}
                placeholder="Adresse e-mail"
                onChange={(e) => onFormUpdate("email", e.target.value)}
                required
                className="contactlea-input"
              />
            </Col>
            <Col xs={12} sm={6} className="px-1">
              <input
                type="tel"
                value={formDetails.phone}
                placeholder="Numéro de téléphone"
                onChange={(e) => onFormUpdate("phone", e.target.value)}
                required
                className="contactlea-input"
              />
            </Col>
            <Col xs={12} className="px-1">
              <textarea
                rows="6"
                value={formDetails.message}
                placeholder="Message"
                onChange={(e) => onFormUpdate("message", e.target.value)}
                required
                className="contactlea-textarea"
              ></textarea>
            </Col>
            <Col xs={12} className="px-1">
              <div style={{ marginBottom: "2rem" }} className="contactlea-rgpd">
                <input
                  type="checkbox"
                  checked={formDetails.rgpd}
                  onChange={(e) => onFormUpdate("rgpd", e.target.checked)}
                  required
                  id="rgpd"
                />
                <label htmlFor="rgpd">
                  J'accepte la <span onClick={() => { setModalContent(<PrivacyPolicy/>); setShowModal(true); }} style={{ cursor: 'pointer', color: '#4cb6ea' }}>politique de confidentialité</span>.
                </label>
              </div>
            </Col>
            <Col>
              <button
                className="contactlea-buttonsend"
                type="submit"
                disabled={isSubmitting}
              >
                {isSubmitting ? <CircularProgress size={24} color="inherit" /> : <span>{buttonText}</span>}
              </button>
            </Col>
          </Row>
        </form>
      </div>
      <Modal showModal={showModal} setShowModal={setShowModal} content={modalContent} isError={isError} />
    </div>
  );
};

export default Contact;